// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7a1ce9bd","453":"600b54db","667":"332dc7d1"}[chunkId] + ".chunk.js";
};